import React from 'react'
import { connect, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Container, Row, Col, Button } from 'react-bootstrap'
import ContactUsDialog from '../../dialog/contactUsDialog'
import { NonGovdisclaimer } from '../../disclaimers/nonGovdisclaimer'
import { Govmarketingdisclaimer } from '../../disclaimers/govMarketing'
import Icon from '../../icon'
import * as E from './footerElements'
import LinkGov from './linkGov'
import { IsSpecialEmployer } from 'application/helpers'
import { isBrandMX, isBrandRS } from 'application/constants/globals'
import NonInsuranceDisclaimer from '../../disclaimers/nonInsuranceDisclaimer'
import InsuranceDisclaimer from '../../disclaimers/insuranceDisclaimer'


export const Footer = ({ consultant, isAuthenticated, applicationRoles }) => {
  const { isConsultant } = applicationRoles
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const result = location.pathname.substring(proposalIndex + 1)
  const urlPath = isConsultant ? '/consultant/' : '/'
  let onHomeUrl = result === 'home'
  let onEstimatesUrl = result === 'estimates'
  const insuranceDisclaimer =
    result === 'review' || result === 'pdfview' || result.indexOf('-') > -1
  const isGov = useSelector((state) => state.user.isGov)
  let isProposal = useSelector((state) => state.individualEstimate.isProposal)
  let isSAGBYO = IsSpecialEmployer('SAGBYO')

  return (
    <E.FooterContainer>
      <E.FooterLogoContainer>
        <Icon src="Logo" />
      </E.FooterLogoContainer>

      {isAuthenticated && (
        <Row>
          <Col sm={5} md={7} lg={8} className="mb-5">
            <E.FooterHeadings>Your dedicated consultant</E.FooterHeadings>

            <E.FooterText>
              {consultant.firstName} is your personal consultant, dedicated to
              guiding you through this process. Want to loop someone into your
              decision? {consultant.firstName} can help bring them up to speed.
            </E.FooterText>
            <E.FooterText>
              <E.FooterHeadings>Consultant name</E.FooterHeadings>
              {consultant.firstName} {consultant.lastName}
            </E.FooterText>
            <E.FooterText>
              <E.FooterHeadings>Email</E.FooterHeadings>
              {consultant.email}
            </E.FooterText>
            {consultant.telephone && (
              <E.FooterText>
                <E.FooterHeadings>Phone number</E.FooterHeadings>
                {consultant.telephone}
              </E.FooterText>
            )}
            <div className="mb-3 mt-3">
              {isConsultant ? (
                <E.FooterPrimaryButton disabled={isConsultant}>
                  Request call back
                </E.FooterPrimaryButton>
              ) : (
                <ContactUsDialog 
                  className="text-brand font-weight-bold btn btn-primary text-white"
                  theme="button"
                  size="sm"
                  extendInMob
                  launchText="Request call back"
                  id="footer.requestcallback"
                />
              )}
            </div>
          </Col>
          <Col sm={7} md={5} lg={4}>
            <h5>Quick links</h5>

            {onHomeUrl ? (
              <E.FooterLinks href="#root" id="footer.homeself">
                Home
              </E.FooterLinks>
            ) : (
              <E.FooterDomLinks to={`${urlPath}home`} id="footer.home">
                Home
              </E.FooterDomLinks>
            )}
            {onEstimatesUrl ? (
              <E.FooterLinks href="#root" id="footer.myquoteself">
                My quote
              </E.FooterLinks>
            ) : (
              <E.FooterDomLinks to={`${urlPath}estimates`} id="footer.myquote">
                My quote
              </E.FooterDomLinks>
            )}
            {global.config.isBrandMX ? (
              <>
                <E.FooterLinks
                  href="https://www.maxxia.com.au/faq"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="footer.faqlink"
                  aria-label="Frequently asked questions"
                >
                  FAQs
                </E.FooterLinks>
                {!isSAGBYO && 
                  <E.FooterLinks
                    href="https://www.maxxia.com.au/insurance-disclosures"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="footer.insurancedisclosure"
                  >
                    Insurance disclosures
                  </E.FooterLinks>
                }
                <div className="mt-4 mb-4">
                  <E.FooterSocialLinks
                    href="https://www.facebook.com/MaxxiaAU/"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="footer.facebookicon"
                  >
                    <Icon src="Facebook" />
                  </E.FooterSocialLinks>
                  <E.FooterSocialLinks
                    href="https://www.instagram.com/maxxia_au/"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="footer.instagramicon"
                  >
                    <Icon src="Instagram" />
                  </E.FooterSocialLinks>
                  <E.FooterSocialLinks
                    href="https://www.linkedin.com/company/maxxia-pty-ltd/"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="footer.linkedinicon"
                  >
                    <Icon src="LinkedIn" />
                  </E.FooterSocialLinks>
                  <E.FooterSocialLinks
                    href="https://www.youtube.com/user/MaxxiaAustralia/videos"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="footer.youtubeicon"
                  >
                    <Icon src="YouTube" />
                  </E.FooterSocialLinks>
                </div>
              </>
            ) : (
              <>
                <LinkGov
                  nonGovLink="https://www.remserv.com.au/faq"
                  govLink="https://www.remservlease.com.au/faq"
                  text="FAQs"
                  ariaLabel="Frequently asked questions"
                />
                <LinkGov
                  nonGovLink="https://www.remserv.com.au/insurance/novated-lease"
                  text="Insurance disclosures"
                />
                {isGov && (
                  <E.FooterLinks
                    href="https://doc.remserv.com.au/Document/RemServ/Novated%20Leasing%20Information%20Booklet%20-%20Feb%202021.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Novated Lease
                    <br /> Information Booklet
                  </E.FooterLinks>
                )}
                {isGov ? null : (
                  <div className="mt-4">
                    <E.FooterSocialLinks
                      href="https://www.facebook.com/remserv/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon src="Facebook" />
                    </E.FooterSocialLinks>
                    <E.FooterSocialLinks
                      href="https://www.instagram.com/remserv_au/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon src="Instagram" />
                    </E.FooterSocialLinks>
                    <E.FooterSocialLinks
                      href="https://www.youtube.com/channel/UCV1zfFN1BZ0p_GojvEfSMDA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon src="YouTube" />
                    </E.FooterSocialLinks>
                    <E.FooterSocialLinks
                      href="https://www.linkedin.com/company/remserv/?originalSubdomain=au"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon src="LinkedIn" />
                    </E.FooterSocialLinks>
                  </div>
                )}
              </>
            )}
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={12}>
          <E.FooterHr />
        </Col>
        <Col xs={12}>
          {isBrandRS && (
          isGov && !isProposal &&
            <Govmarketingdisclaimer />
          ) }
          {isBrandRS && 
          !isGov && <NonGovdisclaimer />}

          {isBrandMX && (insuranceDisclaimer ? (
            <InsuranceDisclaimer />
          ) : (
            <NonInsuranceDisclaimer />))}
        </Col>
      </Row>
    </E.FooterContainer>
  )
}
function mapStateToProps(state) {
  const { consultant } = state
  const { isAuthenticated } = state.authentication
  const applicationRoles = state.applicationRoles

  return {
    consultant,
    isAuthenticated,
    applicationRoles,
  }
}

export default connect(mapStateToProps)(Footer)
